<template>
  <form>
    <div class="image-container mb-3" v-if="previewPath">
      <img :src="previewPath" alt="Uploaded Image Preview" />
    </div>
    <div class="form-group">
      <div ref="dashboardContainer"></div>
    </div>
    <!-- <v-btn :disabled="disabled" @click.prevent="confirmUpload" class="btn btn-primary btn-block mb-2">Confirm upload</v-btn> -->
  </form>
</template>

<script>
import HeicToJpeg from "@/plugins/uppyHeicToJpeg";
import Uppy from "@uppy/core";

import Dashboard from "@uppy/dashboard";
import { nativeCameraOptions } from "@/utils/uppyCamera";
import Russian from "@uppy/locales/lib/ru_RU";
import English from "@uppy/locales/lib/en_US";
// import AwsS3Multipart from "@uppy/aws-s3-multipart";
import XHRUpload from "@uppy/xhr-upload";
import Compressor from "@uppy/compressor";
import "@uppy/core/css/style.css";
import "@uppy/dashboard/css/style.css";
import { RASTER_IMAGE_TYPES } from "@/utils/uploadFileTypes";

export default {
  props: {
    maxFileSizeInBytes: {
      type: Number,
      required: true,
    },
    editedClient: {
      type: Object,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      payload: null,
      previewPath: null,
      disabled: true,
    };
  },
  mounted() {
    this.instantiateUppy();
  },
  beforeDestroy() {
    this.uppy.destroy();
  },
  methods: {
    instantiateUppy() {
      let self = this;
      this.uppy = new Uppy({
        debug: false,
        locale: this.$i18n.locale === "ru" ? Russian : English,
        autoProceed: true,
        allowMultipleUploadBatches: true,
        restrictions: {
          maxFileSize: this.maxFileSizeInBytes,
          minNumberOfFiles: 1,
          maxNumberOfFiles: 10,
          allowedFileTypes: RASTER_IMAGE_TYPES,
        },
      })
        .use(HeicToJpeg, { quality: 0.92 })
        .use(Dashboard, {
          ...nativeCameraOptions(),
          hideUploadButton: true,
          theme: this.theme,
          inline: true,
          width: this.width,
          height: this.height,
          target: this.$refs.dashboardContainer,
          browserBackButtonClose: true,
          proudlyDisplayPoweredByUppy: false,
        })
        .use(Compressor, {
          quality: 0.7,
          limit: 5,
          // Потолок, а не целевой размер: width/height растягивали маленький кадр до
          // 1920×1080 и отключали strict (раздутый результат уходил вместо исходника).
          maxWidth: 1920,
          maxHeight: 1080,
          convertSize: 5000000,
          convertTypes: ["image/png"],
          preserveExif: false,
          locale: {
            strings: {
              // Shown in the Status Bar
              compressingImages: this.$i18n.locale === "ru" ? 'Сжимаем изображение...' : 'Compressing image...',
              compressedX: this.$i18n.locale === "ru" ? 'Сжато %{size} байт' : 'Compressed %{size} bytes',
            },
          },
        })
        .use(XHRUpload, {
          endpoint: `${this.$store.getters.getApiUrl}/api/v1/cars_photo_bookings/${this.$route.params.id}/`, // FT-018
          method: "post",
          formData: true,
          fieldName: "images[]",
          bundle: false,
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
          // api отвечает 204 с пустым телом (head :no_content), а XHRUpload с Uppy 5
          // по умолчанию ждёт JSON и без этого валит уже сохранённое фото.
          getResponseData: () => ({}),
        });

      // this.uppy.on("complete", (event) => {
      //   if (event.successful) {
      //     console.log(result.successful);
      //   }
      // });
      // .use(AwsS3Multipart, {
      //   limit: 10,
      //   companionUrl: `http://localhost:3000/cars_photo_bookings`,
      //   // companionUrl: "http://localhost:3000/api/v1/cars_photo_bookings/${this.car_id}/",
      // });

      // this.uppy.on("upload-success", (file, response) => {
      //   const httpStatus = response.status; // HTTP status code
      //   const httpBody = response.body; // extracted response data

      //   console.log(httpStatus, httpBody);

      //   // do something with file and response
      // });

      // this.uppy.on("complete", (event) => {
      //   event.successful.forEach((element) => {
      //     if (element !== undefined) {
      //       console.log("element", element);
      //       self.axios
      //         .post(
      //           `/api/v1/cars_photo_bookings/${self.$route.params.id}`,
      //           {
      //             cars_photo_bookings: {
      //               name: `${element.s3Multipart.key}`,
      //               url: `https://rentprog.storage.yandexcloud.net/${element.s3Multipart.key}`,
      //             },
      //           },
      //           {
      //             headers: {
      //               Authorization: self.$store.getters.getAuthToken,
      //             },
      //           }
      //         )
      //         .catch((error) => {
      //           this.setError(error, "Ошибка при загрузке файлов!");
      //         });
      //     }
      //   });
      // });

      const uploadedFileData = (file, response) => {
        return JSON.stringify(response.body);
      };
    },
    updatePreviewPath({ path }) {
      this.previewPath = path;

      return this;
    },
    resetUploader() {
      this.uppy.cancelAll();
      this.disabled = true;

      return this;
    },
    confirmUpload() {
      if (this.payload) {
        this.disabled = true;
        this.axios
          .post("/store", { file: this.payload })
          .then(({ data }) => {
            this.updatePreviewPath(data).resetUploader();
            this.$notify("Файлы загружены!", "Вы успешно загрузили файлы!", "success", 5000);
          })
          .catch((err) => {
            console.error(err);

            this.resetUploader();
          });
      } else {
        this.$notify("Ошибка при загрузке!", this.error, "error", 5000);
      }
    },
  },
};
</script>

<style scoped>
.image-container {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: auto;
  margin-left: auto;
}

.image-container>img {
  width: inherit;
  height: inherit;
}
</style>
